import { eventsFlux, EventTypes, useEditorSelector } from '@candulabs/craft';
import React from 'react';

import { BuiltInComponents, toolbarBlackList } from 'craft/constants';
import { useEditor, useSelection } from 'craft/hooks';

import { SelectedToolbarMenu } from './SelectedToolbarMenu';

export const SelectedToolbar = React.memo(() => {
  const { query } = useEditor();

  const { selection } = useSelection();
  const selectionContainsBlackListComponent =
    selection.all.findIndex((nodeId: string) =>
      toolbarBlackList.includes(query.node(nodeId)?.get()?.data?.name as BuiltInComponents),
    ) > -1;
  const draggedEvents = useEditorSelector(
    eventsFlux.selectors.getNodesForEvent(EventTypes.dragged),
  );

  const focusedEvents = useEditorSelector(
    eventsFlux.selectors.getNodesForEvent(EventTypes.focused),
  );

  if (
    selection.isEmpty ||
    selection.hasRootNode ||
    selectionContainsBlackListComponent ||
    draggedEvents.size() !== 0 ||
    focusedEvents.size() !== 0
  ) {
    return null;
  }
  return <SelectedToolbarMenu nodeId={selection.first} />;
});

SelectedToolbar.displayName = 'SelectedToolbar';
